// Shared utility for computing asset display name from make + model fields.
// Use this everywhere that previously referenced `asset.name`.

interface AssetLike {
  make?: string;
  model?: string;
}

/**
 * Returns a human-readable display name built from make and model.
 * Examples:
 *   { make: 'Dell', model: 'Latitude 5540' } → "Dell Latitude 5540"
 *   { make: 'Dell', model: '' }               → "Dell"
 *   { make: '', model: 'Latitude 5540' }      → "Latitude 5540"
 *   { make: '', model: '' }                    → "(Unnamed)"
 */
export function getAssetDisplayName(asset: AssetLike): string {
  const parts: string[] = [];
  if (asset.make?.trim()) parts.push(asset.make.trim());
  if (asset.model?.trim()) parts.push(asset.model.trim());
  return parts.length > 0 ? parts.join(' ') : '(Unnamed)';
}
